import { API, graphqlOperation } from 'aws-amplify';
import { GraphQLResult } from '@aws-amplify/api-graphql';
import { captureError } from '../common/sentry';
import { ManifestProps, TripSheetProps } from '../datastore/tripSheets';
import { saveReceiveManifestSnapshot } from '../graphql/mutations';

type SaveReceiveManifestSnapshotResponse = {
  saveReceiveManifestSnapshot: string;
};

type SaveReceiveManifestSnapshotRequest = {
  tripData: TripSheetProps;
  manifest: ManifestProps;
  triggeredBy?: string;
  mode?: 'SAVE' | 'SUBMIT';
  clientRequestId?: string;
  selectedPartialLineKeys?: Record<string, boolean>;
};

export async function persistReceiveManifestSnapshot(
  input: SaveReceiveManifestSnapshotRequest
): Promise<{ error: string }> {
  try {
    const body = JSON.stringify(input);
    const result = (await API.graphql(
      graphqlOperation(saveReceiveManifestSnapshot, { body })
    )) as GraphQLResult<SaveReceiveManifestSnapshotResponse>;

    const response = result.data?.saveReceiveManifestSnapshot;
    if (!response) {
      return { error: 'Empty response from saveReceiveManifestSnapshot' };
    }

    const parsed = JSON.parse(response) as {
      statusCode?: number;
      body?: unknown;
    };

    if (parsed.statusCode !== 200) {
      return { error: 'saveReceiveManifestSnapshot returned non-200 status' };
    }

    return { error: '' };
  } catch (error) {
    console.error('Error saving receive-manifest snapshot:', error);
    captureError(error, 'persistReceiveManifestSnapshot');
    return { error: 'Failed to persist receive-manifest snapshot' };
  }
}
